const btnFilterManagementEquip = {
  label: 'filtros',
  Typography: 'Ningún resultado encontrado'
};

export default btnFilterManagementEquip;
